
import { NavLink, useLocation } from 'react-router-dom';
import './App.css';
import Header from '../Header/Header';
import { ConfigContext } from '../../assets/contexts/configContext';
import { useEffect, useMemo, useRef, useState } from 'react';
import { compareOptions, getCookieWithShop, getFinalPrice, getShopUIDCookie, setCookieWithShop, setShopUIDCookie } from '../../assets/utils/utils';
import { CART_MAIN_LINK, CATALOG_ITEM_LINK, DEV_SHOP_ID, PROFILE_MAIN_LINK } from '../../assets/utils/constants';
import Router from '../Router/Router';
import mainApi from '../../assets/api/MainApi';
import { constructor_parser } from '../../assets/utils/development/constructor_parser';
import { CartContext } from '../../assets/contexts/cartContext';
import ActivityDetector from '../../assets/hooks/ActivityDetector';
import { ContactContext } from '../../assets/contexts/contactContext';
import ContactPopup from '../ContactPopup/ContactPopup';
import { CallBackContext } from '../../assets/contexts/callBackContext';
import CallBackPopup from '../CallBackPopup/CallBackPopup';
import { UserContext } from '../../assets/contexts/userContext';
import mainAppApi from '../../assets/api/MainAppApi';
import MiniPreloader from '../MiniPreloader/MiniPreloader';

import navWrapper from '../../assets/images/nav-wrapper.webp'


function App() {
  // const platfromTokens = window.platfromTokens
  // const mainLayout = window.mainLayout
  // const cardTokens = window.cardTokens
  // const productPageTokens = window.productPageTokens
  // const { initialConstants, productPageTokens, cardTokens, mainLayout, platfromTokens } = window
  // Check if the client_uid cookie exists


  const headerRef = useRef(null);
  const blackBannerRef = useRef(null);
  const [user, setUser] = useState(null)
  const [constants, setConstants] = useState({
    initialConstants: window.initialConstants,
    productPageTokens: window.productPageTokens,
    cardTokens: window.cardTokens,
    mainLayout: window.mainLayout,
    platfromTokens: window.platfromTokens,
  });

  const PRODUCTION_MODE = process.env.REACT_APP_MODE;
  const shop_id = DEV_SHOP_ID;

  // _________CLIENT_UID_FOR_METRICS_________
  if (!getCookieWithShop('client_uid_', shop_id)) {
    // If not, generate and store the current timestamp with 9 decimal precision
    const timestamp = Date.now() + Math.random().toString().slice(2, 11);
    setCookieWithShop('client_uid_', shop_id, timestamp, 365); // Storing for 365 days
  }

  // Retrieve the stored UID for the shop (if needed)
  const clientUID = getCookieWithShop('client_uid_', shop_id);
  console.log('Client UID for shop', shop_id, ':', clientUID);
  // _________/CLIENT_UID_FOR_METRICS_________

  // _________CLIENT_UID_FOR_METRICS_________
  if (!getCookieWithShop('cart_uid_', shop_id)) {
    // If not, generate and store the current timestamp with 9 decimal precision
    const timestamp = Date.now() + Math.random().toString().slice(2, 11);
    setCookieWithShop('cart_uid_', shop_id, timestamp, 365); // Storing for 365 days
  }
  // _________/CLIENT_UID_FOR_METRICS_________



  const sendActivityPing = () => {
    const clientUID = getCookieWithShop('client_uid_', shop_id); // Получаем UID клиента для магазина, предполагается что функция getCookieWithShop() уже определена
    mainApi.sendActivityPing({ shop_id, client_uid: clientUID }) // Замените на вашу логику вызова API
      .then(response => console.log('Успешный пинг активности', response))
      .catch(error => console.error('Ошибка при отправке пинга активности', error));
  };



  const [cart, setCart] = useState([]);
  const cartLocalStorageKey = `cart_${shop_id}`;


  useEffect(() => {
    mainApi.getConstructor({ shop_id: shop_id })
      .then((res) => {
        constructor_parser(res, setConstants, shop_id)
      })
      .catch((err) => {
        console.log(err)
      })

    // Получаем корзину из localStorage с учетом shop_id
    if (window.location.href.indexOf('paid=true') >= 0) return
    let cartArray = JSON.parse(localStorage.getItem(cartLocalStorageKey)) || [];
    setCart(cartArray)
    console.log({ cartArray })


  }, [shop_id]);


  function handleRemoveFromCart(itemToRemove, isAll) {
    let cartArray = JSON.parse(localStorage.getItem(cartLocalStorageKey)) || [];
    const clientUID = getCookieWithShop('client_uid_', shop_id);
    const cartUID = getCookieWithShop('cart_uid_', shop_id);

    // Define a helper function to compare item options for equality
    function isSameItemOptions(cartItem, item) {
      if (!item.options || item.options.length === 0 || !cartItem.options || cartItem.options.length === 0) {
        return true; // Consider items the same if either has no options
      }
      const comparisonResult = compareOptions(item.options, cartItem.options);
      return comparisonResult.differences.length === 0;
    }
    const itemIndex = cartArray.findIndex(cartItem =>
      cartItem._id === itemToRemove._id && isSameItemOptions(cartItem, itemToRemove));

    if (isAll) {
      // Remove all instances of the item with the same options

      mainApi.sendCartChange({
        shop_id,
        client_uid: clientUID,
        cart_uid: cartUID,
        item_id: itemToRemove._id,
        options: itemToRemove.options ? itemToRemove.options : [],
        amount: cartArray[itemIndex].count.toString(),
        direction: false,
      }) // Замените на вашу логику вызова API
        .then(response => {
          console.log('Успешное удаление товара из корзины1', response)
        })
        .catch(error => console.error('Ошибка удалении товара из корзины', error));
      cartArray = cartArray.filter(cartItem =>
        !(cartItem._id === itemToRemove._id && isSameItemOptions(cartItem, itemToRemove)));
    } else {
      // Find the index of the item to decrement quantity or remove

      if (itemIndex !== -1) {
        if (cartArray[itemIndex].count > 1) {
          // Decrement the count
          const COUNT = cartArray[itemIndex].count
          mainApi.sendCartChange({
            shop_id,
            client_uid: clientUID,
            cart_uid: cartUID,
            item_id: itemToRemove._id,
            options: itemToRemove.options ? itemToRemove.options : [],
            amount: COUNT.toString(),
            direction: false,
          }) // Замените на вашу логику вызова API
            .then(response => {
              console.log('Успешное удаление товара из корзины', response)
              mainApi.sendCartChange({
                shop_id,
                client_uid: clientUID,
                cart_uid: cartUID,
                item_id: itemToRemove._id,
                options: itemToRemove.options ? itemToRemove.options : [],
                amount: (COUNT - 1).toString(),
                direction: true,
              }) // Замените на вашу логику вызова API
                .then(response => {
                  console.log('Успешное добавления товара в корзину', response)
                })
                .catch(error => console.error('Ошибка добавления товара в корзину', error));
            })
            .catch(error => console.error('Ошибка удалении товара из корзины', error));
          cartArray[itemIndex].count -= 1;

        } else {
          // Remove the item completely if count is 1
          mainApi.sendCartChange({
            shop_id,
            client_uid: clientUID,
            cart_uid: cartUID,
            item_id: itemToRemove._id,
            options: itemToRemove.options ? itemToRemove.options : [],
            amount: cartArray[itemIndex].count.toString(),
            direction: false,
          }) // Замените на вашу логику вызова API
            .then(response => {

              console.log('Успешное удаление товара из корзины', response)
            })
            .catch(error => console.error('Ошибка удалении товара из корзины', error));
          cartArray.splice(itemIndex, 1);
        }
      }
    }

    // Update the cart in both local state and localStorage
    setCart(cartArray);
    localStorage.setItem(cartLocalStorageKey, JSON.stringify(cartArray));
  }


  function handleAddToCart(item) {
    // Retrieve the cart from localStorage and parse it; initialize as empty array if not found
    let cartArray = JSON.parse(localStorage.getItem(cartLocalStorageKey)) || [];
    const clientUID = getCookieWithShop('client_uid_', shop_id);
    const cartUID = getCookieWithShop('cart_uid_', shop_id);

    // Define a helper function to compare item options
    function isSameItemOptions(cartItem, newItem) {
      if (!newItem.options || newItem.options.length === 0 || !cartItem.options || cartItem.options.length === 0) {
        return true; // Treat as same if either item doesn't have options
      }
      const comparisonResult = compareOptions(newItem.options, cartItem.options);
      return comparisonResult.differences.length === 0;
    }

    // Find if the item already exists in the cart with the same options
    const existingCartItemIndex = cartArray.findIndex(cartItem =>
      cartItem._id === item._id && isSameItemOptions(cartItem, item));

    mainApi.sendCartChange({
      shop_id,
      client_uid: clientUID,
      cart_uid: cartUID,
      item_id: item._id,
      options: item.options ? item.options : [],
      amount: '1',
      direction: true,
    }) // Замените на вашу логику вызова API
      .then(response => {
        console.log('Успешное добавления товара в корзину', response)
      })
      .catch(error => console.error('Ошибка добавления товара в корзину', error));
    if (existingCartItemIndex !== -1) {
      // Item with same ID and options found, increase count
      cartArray[existingCartItemIndex].count += 1;
    } else {
      // No matching item found, add new item to cart
      const newItem = {
        _id: item._id,
        options: item.options || [], // Ensure options is always an array
        count: 1,
      };
      cartArray.push(newItem);
    }

    // Update the cart in both local state and localStorage
    setCart(cartArray);
    localStorage.setItem(cartLocalStorageKey, JSON.stringify(cartArray));
  }




  const contextValue = useMemo(() => constants, [constants]);
  const [isContactPopupOpen, setContactPopupOpen] = useState(false);
  const [isCallBackPopupOpen, setCallBackPopupOpen] = useState(false);

  const location = useLocation()

  const [personalPopup, setPersonalPopup] = useState({
    phone: "",
    first_name: "",
    email: "",
  });

  const [personalValidityPopup, setPersonalValidityPopup] = useState({
    phone: {},
    email: {},
  });

  const [preloaders, setPreloaders] = useState({
    getUser: true,
  })
  useEffect(() => {
    mainAppApi.getMe()
      .then((res) => {
        console.log(res)
        setUser(res)
        setPreloaders(prevValue => ({
          ...prevValue,
          getUser: false,
        }))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <ConfigContext.Provider value={contextValue}>
      <ActivityDetector sendActivityPing={sendActivityPing} />
      <CartContext.Provider value={{
        cart,
        handleAddToCart,
        handleRemoveFromCart,
        setCart,
      }}>
        <CallBackContext.Provider value={{
          isCallBackPopupOpen,
          setCallBackPopupOpen,
        }}>
          <ContactContext.Provider value={{
            isContactPopupOpen,
            setContactPopupOpen,
          }}>
            <UserContext.Provider value={{
              user,
              setUser,
            }}>
              { false?
                <div className='app__preloader'>
                  <MiniPreloader />
                </div>

                :
                contextValue.initialConstants.SHOP_ID_FOR_API && contextValue.initialConstants.SHOP_ID_FOR_API !== '{{SHOP_ID_FOR_API}}' ?
                  <div className="app">
                    {
                      [PROFILE_MAIN_LINK].some(segment => location.pathname.includes(segment)) ?
                        null
                        :
                        <Header headerRef={headerRef} blackBannerRef={blackBannerRef} />
                    }
                    <Router blackBannerRef={blackBannerRef} />
                    {/* {location.pathname !== `/${ABOUT_US_PAGE_LINK}` ?
                    <Footer />
                    : null} */}
                    <ContactPopup
                      personal={personalPopup}
                      setPersonal={setPersonalPopup}
                      setPersonalValidity={setPersonalValidityPopup}
                      personalValidity={personalValidityPopup}
                    />
                    <CallBackPopup
                      personal={personalPopup}
                      setPersonal={setPersonalPopup}
                      setPersonalValidity={setPersonalValidityPopup}
                      personalValidity={personalValidityPopup}
                    />
                    {
                      [CART_MAIN_LINK, CATALOG_ITEM_LINK].some(segment => location.pathname.includes(segment)) ?
                        null
                        :
                        <div className='app__nav-wrapper'>
                          <div className='app__nav-block app__nav-block_left'>
                            <NavLink
                              to="/"
                              className={({ isActive }) => (`app__nav-link ${isActive ? 'app__nav-link_active' : ''}`)}
                            >
                              <svg className='app__nav-link-icon' width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className='app__nav-link-icon-fill' fill-rule="evenodd" clip-rule="evenodd" d="M15.2299 5.26656C13.9329 4.20542 12.0678 4.20542 10.7708 5.26656L4.08157 10.7396C3.57315 11.1556 3.75632 11.9733 4.39362 12.1326C5.47258 12.4023 6.22949 13.3718 6.22949 14.4839V19.7259C6.22949 21.6704 7.80582 23.2468 9.75033 23.2468H16.2503C18.1948 23.2468 19.7712 21.6704 19.7712 19.7259V14.4839C19.7712 13.3718 20.5281 12.4023 21.607 12.1326C22.2443 11.9733 22.4275 11.1556 21.9191 10.7396L15.2299 5.26656ZM9.74179 4.00888C11.6373 2.45798 14.3633 2.45798 16.2589 4.00888L22.9481 9.48189C24.4909 10.7442 23.9351 13.2256 22.0012 13.7091C21.6456 13.798 21.3962 14.1174 21.3962 14.4839V19.7259C21.3962 22.5679 19.0923 24.8718 16.2503 24.8718H9.75033C6.90836 24.8718 4.60449 22.5679 4.60449 19.7259V14.4839C4.60449 14.1174 4.35506 13.798 3.9995 13.7091C2.06559 13.2256 1.50972 10.7442 3.05256 9.48189L9.74179 4.00888Z" fill="black" />
                                <path className='app__nav-link-icon-fill' fill-rule="evenodd" clip-rule="evenodd" d="M13.0004 16.2051C12.2525 16.2051 11.6462 16.8114 11.6462 17.5592C11.6462 18.3071 12.2525 18.9134 13.0004 18.9134C13.7483 18.9134 14.3545 18.3071 14.3545 17.5592C14.3545 16.8114 13.7483 16.2051 13.0004 16.2051ZM10.0212 17.5592C10.0212 15.9139 11.355 14.5801 13.0004 14.5801C14.6457 14.5801 15.9795 15.9139 15.9795 17.5592C15.9795 19.2046 14.6457 20.5384 13.0004 20.5384C11.355 20.5384 10.0212 19.2046 10.0212 17.5592Z" fill="black" />
                              </svg>
                            </NavLink>
                            <NavLink
                              to="/search"
                              className={({ isActive }) => (`app__nav-link ${isActive ? 'app__nav-link_active' : ''}`)}
                            >
                              <svg className='app__nav-link-icon' width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4.64" y="4.22656" width="18" height="18" rx="9" fill="white" />
                                <path className='app__nav-link-icon-stroke' d="M19.49 19.0766L22.64 22.2266M21.74 12.7766C21.74 8.05453 17.912 4.22656 13.19 4.22656C8.46796 4.22656 4.64 8.05453 4.64 12.7766C4.64 17.4986 8.46796 21.3266 13.19 21.3266C17.912 21.3266 21.74 17.4986 21.74 12.7766Z" stroke="black" stroke-width="1.88416" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </NavLink>
                          </div>
                          <div className='app__nav-block app__nav-block_right'>
                            <NavLink
                              to="/favorite"
                              className={({ isActive }) => (`app__nav-link ${isActive ? 'app__nav-link_active' : ''}`)}
                            >
                              <svg className='app__nav-link-icon' width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className='app__nav-link-icon-stroke' d="M17.6773 3.22656C21.5579 3.22656 24.16 6.95156 24.16 10.4204C24.16 17.4616 13.3568 23.2266 13.16 23.2266C12.9632 23.2266 2.15997 17.4616 2.15997 10.4204C2.15997 6.95156 4.76208 3.22656 8.64264 3.22656C10.861 3.22656 12.3179 4.35781 13.16 5.36531C14.0021 4.35781 15.459 3.22656 17.6773 3.22656Z" fill="white" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </NavLink>
                            <NavLink
                              to="/profile"
                              className={({ isActive }) => (`app__nav-link ${isActive ? 'app__nav-link_active' : ''}`)}
                            >
                              <svg className='app__nav-link-icon' width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className='app__nav-link-icon-fill' fill-rule="evenodd" clip-rule="evenodd" d="M9.37654 18.5372C7.99168 19.2296 7.46826 20.0243 7.46826 20.6419C7.46826 21.2595 7.99168 22.0542 9.37654 22.7467C10.7091 23.4129 12.6112 23.8503 14.7599 23.8503C16.9087 23.8503 18.8108 23.4129 20.1433 22.7467C21.5282 22.0542 22.0516 21.2595 22.0516 20.6419C22.0516 20.0243 21.5282 19.2296 20.1433 18.5372C18.8108 17.8709 16.9087 17.4336 14.7599 17.4336C12.6112 17.4336 10.7091 17.8709 9.37654 18.5372ZM8.59391 16.972C10.2171 16.1603 12.3984 15.6836 14.7599 15.6836C17.1215 15.6836 19.3027 16.1603 20.9259 16.972C22.4968 17.7574 23.8016 19.0044 23.8016 20.6419C23.8016 22.2795 22.4968 23.5265 20.9259 24.3119C19.3027 25.1235 17.1215 25.6003 14.7599 25.6003C12.3984 25.6003 10.2171 25.1235 8.59391 24.3119C7.02302 23.5265 5.71826 22.2795 5.71826 20.6419C5.71826 19.0044 7.02302 17.7574 8.59391 16.972Z" fill="black" />
                                <path className='app__nav-link-icon-fill' fill-rule="evenodd" clip-rule="evenodd" d="M14.7604 4.60156C12.6664 4.60156 10.9688 6.29915 10.9688 8.39323C10.9688 10.4873 12.6664 12.1849 14.7604 12.1849C16.8545 12.1849 18.5521 10.4873 18.5521 8.39323C18.5521 6.29915 16.8545 4.60156 14.7604 4.60156ZM9.21878 8.39323C9.21878 5.33265 11.6999 2.85156 14.7604 2.85156C17.821 2.85156 20.3021 5.33265 20.3021 8.39323C20.3021 11.4538 17.821 13.9349 14.7604 13.9349C11.6999 13.9349 9.21878 11.4538 9.21878 8.39323Z" fill="black" />
                              </svg>
                            </NavLink>
                          </div>

                          <img className='app__nav-bg' src={navWrapper} alt='' />
                        </div>
                    }


                  </div>
                  :
                  null
              }

            </UserContext.Provider>
          </ContactContext.Provider>
        </CallBackContext.Provider>

      </CartContext.Provider>
    </ConfigContext.Provider>
  );
}

export default App;
